import * as React from 'react'
import { FormattedMessage } from 'react-intl'

import { Body, Header, Icon, IconPlaceholder, JoinButton, Meta, Name, Root, Stat, StatDot, Stats } from './elements/invite'
import { fieldValue } from './inviteUrl'

interface Props {
  title?: string
  url?: string
  description?: string
  thumbnail?: {
    proxyURL?: string
    url?: string
  }
  fields?: { name?: string; value?: string }[]
}

const InviteCard = ({ title, url, description, thumbnail, fields }: Props) => {
  const icon = (thumbnail && (thumbnail.proxyURL || thumbnail.url)) || null
  const online = fieldValue(fields, 'Online')
  const members = fieldValue(fields, 'Members')
  const initial = title ? title.charAt(0) : '?'

  return (
    <Root className="invite-embed">
      <Header>
        <FormattedMessage id="invite.header" />
      </Header>
      <Body>
        {icon ? <Icon src={icon} alt="" /> : <IconPlaceholder>{initial}</IconPlaceholder>}
        <Meta>
          <Name href={url} target="_blank" rel="noreferrer">
            {title}
          </Name>
          <Stats>
            {online != null && (
              <Stat>
                <StatDot online />
                {online} Online
              </Stat>
            )}
            {members != null && (
              <Stat>
                <StatDot />
                {members} Members
              </Stat>
            )}
            {online == null && members == null && description ? <Stat>{description}</Stat> : null}
          </Stats>
        </Meta>
        {url && (
          <JoinButton href={url} target="_blank" rel="noreferrer">
            <FormattedMessage id="header.join" />
          </JoinButton>
        )}
      </Body>
    </Root>
  )
}

export default InviteCard



// WEBPACK FOOTER //
// ./src/components/Messages/Message/Embed/InviteCard.tsx